import { COUNTRIES } from '@/constants';
import { z } from 'zod';
import { type TranslationKey } from '@/i18n/translation-key';

export const addressSchemaFactory = (t: (key: TranslationKey) => string) =>
  z.object({
    name: z
      .string()
      .min(2, t('organization.validation.addressNameMinLength'))
      .max(100, t('organization.validation.addressMaxLength'))
      .trim(),
    address1: z
      .string()
      .min(5, t('organization.validation.addressMinLength'))
      .max(100, t('organization.validation.addressMaxLength'))
      .trim(),
    address2: z
      .string()
      .max(100, t('organization.validation.addressMaxLength'))
      .optional()
      .transform((val) => (val === '' ? undefined : val)),
    city: z
      .string()
      .min(2, t('organization.validation.cityMinLength'))
      .max(50, t('organization.validation.cityMaxLength'))
      .trim(),
    country: z.enum(COUNTRIES, {
      message: t('organization.validation.countryList'),
    }),
    postCode: z
      .string()
      .min(3, t('organization.validation.postalCodeMinLength'))
      .max(10, t('organization.validation.postalCodeMaxLength'))
      .trim()
      .regex(/^[a-zA-Z0-9-\s]+$/, t('organization.validation.postalCodeCharacters')),
    vat: z
      .string()
      .max(20, t('organization.validation.vatMaxLength'))
      .refine((val) => val === '' || /^[A-Za-z0-9.]{9,12}$/.test(val), t('organization.validation.vatCharacters'))
      .optional()
      .transform((val) => (val === '' ? undefined : val)),
  });

export const editActiveOrganizationSchemaFactory = (t: (key: TranslationKey) => string) => {
  return z.object({
    general: z.object({
      name: z
        .string()
        .min(2, t('organization.validation.nameMinLength'))
        .max(100, t('organization.validation.nameMaxLength'))
        .trim(),
    }),
    billingAddress: addressSchemaFactory(t).partial(),
  });
};
